import React, { useEffect } from 'react';
import { AVAILABLE_BILL_MODALS } from './consts';
import { BILL_MODALS_STYLES } from './styles';
import { UserMessage } from '../../../../../../DesignSystem/LiliUserMessage/UserMessage';
import { useStore } from '../../../../../../store';
import { ReactComponent as CloseIcon } from '../../../../../../assets/svg/shared/icon-close.svg';
import BillActionsMenu from './Modals/BillActionsMenu';
import MarkBillAsPaid from './Modals/MarkBillAsPaid';
import Spinner, { SpinnerColor } from '../../../../../../generic-components/Spinner';
import { ErrorModal } from '../../../../../../generic-components/ErrorModal';
import { MarkBillAsUnpaid } from './Modals/MarkBillAsUnpaid/MarkBillAsUnpaid';
import MarkBillAsCanceled from './Modals/MarkBillAsCanceled';
import { CancelDetailsRequest } from './Modals/CancelDetailsRequest/CancelDetailsRequest';

const BillsModalsHub = () => {
  const setActiveBillModal = useStore(state => state.setActiveBillModal);
  const selectedBill = useStore(state => state.selectedBill);
  const activeBillModal = useStore(state => state.activeBillModal);
  const billError = useStore(state => state.billError);
  const resetError = useStore(state => state.resetError);
  const setSelectedBill = useStore(state => state.setSelectedBill);
  const activeMainWrapperStyles = BILL_MODALS_STYLES[activeBillModal]?.main;
  const activeContentWrapperStyles = BILL_MODALS_STYLES[activeBillModal]?.content;
  const activeExitIconStyles = BILL_MODALS_STYLES[activeBillModal]?.exit;
  useEffect(() => setActiveBillModal(AVAILABLE_BILL_MODALS.NONE), []);
  const onClose = () => {
    setActiveBillModal(AVAILABLE_BILL_MODALS.NONE);
    setSelectedBill(null);
    if (billError) resetError();
  };
  if (activeBillModal === AVAILABLE_BILL_MODALS.NONE) return null;
  if (activeBillModal === AVAILABLE_BILL_MODALS.ERROR && billError) {
    return (
      <ErrorModal onClose={onClose} text={billError?.localizedMessage} onButtonClick={onClose} />
    );
  }
  if (!selectedBill) return null;
  return (
    <UserMessage
      id='bills-modals-hub'
      mainWrapperOverrideClassName={activeMainWrapperStyles}
      contentWrapperOverrideClassName={activeContentWrapperStyles}
      onClick={onClose}
    >
      {!!activeExitIconStyles && (
        <CloseIcon className={`${activeExitIconStyles} rounded-full fill-bw07 hover:bg-bw02`} onClick={onClose} />
      )}
      {activeBillModal === AVAILABLE_BILL_MODALS.SPINNER && <Spinner spinnerColor={SpinnerColor.Blue} height='60px' width='60px' />}
      {activeBillModal === AVAILABLE_BILL_MODALS.ACTIONS_MENU && <BillActionsMenu />}
      {activeBillModal === AVAILABLE_BILL_MODALS.MARK_AS_PAID && <MarkBillAsPaid amount={selectedBill.amount} billId={selectedBill.billId} onClose={onClose} />}
      {activeBillModal === AVAILABLE_BILL_MODALS.MARK_AS_UNPAID && <MarkBillAsUnpaid billId={selectedBill.billId} billNumber={selectedBill.billNumber} onClose={onClose} />}
      {activeBillModal === AVAILABLE_BILL_MODALS.MARK_AS_CANCELED && <MarkBillAsCanceled billNumber={selectedBill.billNumber} billStatus={selectedBill.calculatedStatus} billId={selectedBill.billId} onClose={onClose} />}
      {activeBillModal === AVAILABLE_BILL_MODALS.CANCEL_DETAILS_REQUEST && <CancelDetailsRequest billId={selectedBill.billId} />}
    </UserMessage>
  );
};

/*

{activeModal === HUB_MODALS.ACTIONS_MENU && <InvoiceActionsMenu referenceElement={invoiceActionsReferenceElement} onClose={onClose} />}
      {activeModal === HUB_MODALS.SHARE_LINK && <ShareLinkAction linkToShare={getInvoiceShareLink(selectedInvoice?.paymentUrl)} onClose={onClose} />}
      {activeModal === HUB_MODALS.CANCEL_INVOICE && <CancelInvoice externalId={selectedInvoice?.externalId} invoiceNumber={selectedInvoice?.invoiceNumber} invoiceStatus={selectedInvoice?.status} onClose={onClose} />}
      {activeModal === HUB_MODALS.SPINNER && <Spinner lineColor='#019EAC' height='60px' width='60px' />}
      {activeModal === HUB_MODALS.MARK_AS_PAID && <MarkBillAsPaid onClose={onClose} invoiceAmount={selectedInvoice?.amount} externalId={selectedInvoice?.externalId} invoiceStatus={selectedInvoice?.status} />}
      {activeModal === HUB_MODALS.MARK_AS_UNPAID && <MarkAsUnpaid onClose={onClose} externalId={selectedInvoice?.externalId} invoiceStatus={selectedInvoice?.status} />}
      {activeModal === HUB_MODALS.SOCIAL_SHARE && <SocialSharePopUp onClose={() => navigate(`/${VIEWS_MAP.INVOICES}`)} recipientName={selectedInvoice?.recipient} invoiceNumber={selectedInvoice?.invoiceNumber} paymentUrl={selectedInvoice?.paymentUrl} />}
      {activeModal === HUB_MODALS.INVOICE_SETTINGS && <InvoiceSettingsSubMenu onClose={onClose} referenceElement={invoiceSettingsReferenceElement} />}
 */

export default BillsModalsHub;
